'use client';

import * as React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import type { ButtonProps } from '@/components/ui/button';

export type MotionButtonProps = ButtonProps;

export function MotionButton({ className, ...props }: MotionButtonProps) {
  const rm = useReducedMotion();
  return (
    <motion.div
      whileHover={rm ? undefined : { y: -2, scale: 1.02 }}
      whileTap={rm ? undefined : { scale: 0.985 }}
      transition={{ type: 'spring', stiffness: 300, damping: 22 }}
      className="inline-block"
    >
      <Button
        {...props}
        className={`focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ${className ?? ''}`}
      />
    </motion.div>
  );
}
